import { render, staticRenderFns } from "./BdQueue.vue?vue&type=template&id=35a053a2&"
import script from "./BdQueue.vue?vue&type=script&lang=js&"
export * from "./BdQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports